"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UCContractServiceItemNameEditor = class UCContractServiceItemNameEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getItems(...args) {
        const value = this.value;
        if (this._items && value === this._items) {
            return this._items;
        }
        if (value == null || value.length == 0) {
            this._items = [];
            this.$emit('input', this._items);
            return this._items;
        }
        this._items = value;
        return value;
    }
    addItem(...args) {
        this.items.push(this.newItem());
        this._items = this.items.slice();
        this.items = this._items;
        this.$emit('input', this._items);
    }
    newItem(...args) {
        return {
            name: null,
            include_period: null,
            period_format: null,
            language: null
        };
    }
    removeItem(...args) {
        const [item] = args;
        console.log('removeItem', item, _.indexOf(this._items));
        const removed = _.remove(this._items, p => p === item);
        if (removed && removed.length) {
            this._items = this.items.slice();
            this.items = this._items;
            this.$emit('input', this._items);
        }
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    disabled;
    onDisabled(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("disabled");
    }
    periodFormats;
    async $$load_periodFormats() {
        return this.$app.repo.get('ui_metadata', { path: 'billing_period_formats' });
    }
    languages;
    items;
    async $$load_items() {
        return this.getItems();
    }
    ux;
    dataMembers = ['periodFormats', 'languages', 'items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                periodFormats: null,
                languages: [{
                        value: "hu",
                        name: this.$fn.pgettext("languages", "hungarian"),
                    },
                    {
                        value: "it",
                        name: this.$fn.pgettext("languages", "italian"),
                    },
                    {
                        value: "en",
                        name: this.$fn.pgettext("languages", "english"),
                    },
                ],
                items: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_4207795475682514_script_8998_getActionArgs_value($event) {
        this.removeItem($event.scope.item);
    }
    async act_4207795475682514_script_8998_getActionArgs($event) {
        return {
            value: () => this.act_4207795475682514_script_8998_getActionArgs_value($event),
        };
    }
    async evh_4207795475682514_clickPreventStop(event, scope) {
        return await this.actions.evh_4207795475682514_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_9000_getActionArgs_value($event) {
        this.addItem();
    }
    async act_1040167445267876_script_9000_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_9000_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_clickPreventStop(event, scope) {
        return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8996 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8995 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8996,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8995],
        });
        const act_4207795475682514_script_8998 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4207795475682514_script_8998_getActionArgs,
            events: [],
        });
        const evh_4207795475682514_clickPreventStop_8997 = new core_1.actions.EventHandlerImpl({
            action: act_4207795475682514_script_8998,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_4207795475682514_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4207795475682514_clickPreventStop_8997],
        });
        const act_1040167445267876_script_9000 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_9000_getActionArgs,
            displayName: "addItem",
            events: [],
        });
        const evh_1040167445267876_clickPreventStop_8999 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_9000,
            event: "click.prevent.stop",
            displayName: "addItem",
        });
        const evh_1040167445267876_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_clickPreventStop_8999],
        });
        return {
            act_7315092382398562_reloadComponentData_8996,
            evh_7315092382398562_reload_8995,
            evh_7315092382398562_reload,
            act_4207795475682514_script_8998,
            evh_4207795475682514_clickPreventStop_8997,
            evh_4207795475682514_clickPreventStop,
            act_1040167445267876_script_9000,
            evh_1040167445267876_clickPreventStop_8999,
            evh_1040167445267876_clickPreventStop,
            addItem: act_1040167445267876_script_9000,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], UCContractServiceItemNameEditor.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceItemNameEditor.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], UCContractServiceItemNameEditor.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceItemNameEditor.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UCContractServiceItemNameEditor.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceItemNameEditor.prototype, "onReadonly", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UCContractServiceItemNameEditor.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceItemNameEditor.prototype, "onDisabled", null);
UCContractServiceItemNameEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], UCContractServiceItemNameEditor);
exports.default = UCContractServiceItemNameEditor;
vue_property_decorator_1.Vue.component("UCContractServiceItemNameEditor", UCContractServiceItemNameEditor);
